const auth0Scope = "read:current_user read:current_user_metadata update:current_user_metadata";
export default auth0Scope;